module.exports = __webpack_public_path__ + "static/img/topimg.a86d178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/skin/topimg.png
// module id = weJV
// module chunks = 0